import sha1 from 'js-sha1'

import { GtmAPI } from '@termly-web/common'


export const pushImpactUttTracking = (userInfo) => {
  const impactCustomerId = userInfo.guest ? '' : userInfo.id
  const impactCustomerEmail = userInfo.guest ? '' : sha1(userInfo.email)

  GtmAPI.push({
    impactCustomerId,
    impactCustomerEmail,
  })
}
